import type { Schema } from './types'

export const shared: Schema = {
  'attach-see-more-christmas': {
    default: false,
  },
  'authwizard-validate-email': {
    default: true,
  },
  'basket-add-a-gift-note': {
    default: false,
  },
  'basket-personalised-promotions': {
    default: false,
  },
  'checkout-enable-spa': {
    default: false,
  },
  'customer-recipient-tracking': {
    default: true,
  },
  'customer-order-conf-redesign': {
    default: false,
  },
  'customer-show-order-confirmation-alert': {
    default: false,
  },
  'order-conf-promotion-banner': {
    default: false,
  },
  'ecards-xsell': {
    default: false,
  },
  'loyalty-plus-show-savings': {
    default: false,
  },
  'loyalty-plus-x-sell-modal-v2': {
    default: true,
  },
  'payment-options-show-browser-pay': {
    default: false,
  },
  'show-christmas-delivery-date-text': {
    default: false,
  },
  'show-mail-strike-alert': {
    default: false,
  },
  'enable-fav-toast-notification': {
    default: false,
  },
  'customer-private-email-modal': {
    default: false,
  },
  'checkout-feat-promo-book': {
    default: false,
  },
  'incident-banner': {
    default: false,
  },
  'customer-oc-holiday-icon': {
    default: false,
  },
  'chk-feat-empty-basket-redirect': {
    default: false,
  },
}
